import { submitToOpenApi } from '@wellbeingxltd/fe-lib/api/dist'
import { submitToApi } from 'awsApi'
import { URL } from './endpoints'

export const ACTIONS = {
    GET_RESOURCES: {
        START: 'GET_RESOURCES START',
        SUCCESS: 'GET_RESOURCES SUCCESS',
        FAILURE: 'GET_RESOURCES FAILURE',
    },
    GET_RESOURCE: {
        START: 'GET_RESOURCE START',
        SUCCESS: 'GET_RESOURCE SUCCESS',
        FAILURE: 'GET_RESOURCE FAILURE',
    },
    GET_RESOURCE_PUBLIC: {
        START: 'GET_RESOURCE_PUBLIC START',
        SUCCESS: 'GET_RESOURCE_PUBLIC SUCCESS',
        FAILURE: 'GET_RESOURCE_PUBLIC FAILURE',
    },
    GET_RECOMMENDED_RESOURCES: {
        START: 'GET_RECOMMENDED_RESOURCES START',
        SUCCESS: 'GET_RECOMMENDED_RESOURCES SUCCESS',
        FAILURE: 'GET_RECOMMENDED_RESOURCES FAILURE',
    },
    GET_IN_HOUSE_BENEFITS: {
        START: 'GET_IN_HOUSE_BENEFITS START',
        SUCCESS: 'GET_IN_HOUSE_BENEFITS SUCCESS',
        FAILURE: 'GET_IN_HOUSE_BENEFITS FAILURE',
    },
    GET_TOP_RESOURCES: {
        START: 'GET_TOP_RESOURCES START',
        SUCCESS: 'GET_TOP_RESOURCES SUCCESS',
        FAILURE: 'GET_TOP_RESOURCES FAILURE',
    },
    GET_FILTERED_RESOURCES: {
        START: 'GET_FILTERED_RESOURCES START',
        SUCCESS: 'GET_FILTERED_RESOURCES SUCCESS',
        FAILURE: 'GET_FILTERED_RESOURCES FAILURE',
    },

    CLEAN_RESOURCE: 'CLEAN_RESOURCE',
    CLEAN_FILTERED_RESOURCES: 'CLEAN_FILTERED_RESOURCES',
    CHANGE_FILTERS: 'CHANGE_FILTERS',
    CLEAR_FILTERS: 'CLEAR_FILTERS',
    CHANGE_BOOKING_STATE: 'CHANGE_BOOKING_STATE',
}

export const getResources = () => async dispatch => {
    dispatch({ type: ACTIONS.GET_RESOURCES.START })
    try {
        const { payload } = await submitToApi({
            path: URL.DIRECTORY.V3_DIRECTORY_USER_RETRIEVE_ALL,
            url: URL.DIRECTORY.BASE,
        })
        dispatch({ type: ACTIONS.GET_RESOURCES.SUCCESS, data: payload.data })
    } catch (error) {
        dispatch({ type: ACTIONS.GET_RESOURCES.FAILURE, error })
    }
}
export const getResourcesFiltered = (value, pilotTag) => async dispatch => {
    dispatch({ type: ACTIONS.GET_FILTERED_RESOURCES.START })
    try {
        const { payload } = await submitToApi({
            path: URL.RESOURCES.V6_RESOURCES_USER_SEARCH_RETRIEVE,
            url: URL.RESOURCES.BASE,
            query: { searchQuery: value, clientName: pilotTag },
        })
        dispatch({ type: ACTIONS.GET_FILTERED_RESOURCES.SUCCESS, data: payload.data })
    } catch (error) {
        console.log(error)
        dispatch({ type: ACTIONS.GET_FILTERED_RESOURCES.FAILURE, error })
    }
}

export const cleanFilteredResource = () => dispatch => dispatch({ type: ACTIONS.CLEAN_FILTERED_RESOURCES })

export const getRecommendedResources =
    ({ userId, pilotTag }) =>
    async dispatch => {
        dispatch({ type: ACTIONS.GET_RECOMMENDED_RESOURCES.START })
        try {
            const { payload } = await submitToApi({
                path: URL.RECOMMENDER.V6_ANALYTICS_RECOMMENDED_RESOURCES_RETRIEVE,
                query: { key: `output/${userId}.json`, userId, pilotTag },
                url: URL.RECOMMENDER.BASE,
            })
            dispatch({ type: ACTIONS.GET_RECOMMENDED_RESOURCES.SUCCESS, data: payload.data })
        } catch (error) {
            dispatch({ type: ACTIONS.GET_RECOMMENDED_RESOURCES.FAILURE, error })
        }
    }

export const getInhouseBenefits = () => async dispatch => {
    dispatch({ type: ACTIONS.GET_IN_HOUSE_BENEFITS.START })
    try {
        const { payload } = await submitToApi({
            path: URL.DIRECTORY.V3_DIRECTORY_USER_RETRIEVE_ALL,
            query: { companyBenefits: true },
            url: URL.DIRECTORY.BASE,
        })
        dispatch({ type: ACTIONS.GET_IN_HOUSE_BENEFITS.SUCCESS, data: payload.data })
    } catch (error) {
        dispatch({ type: ACTIONS.GET_IN_HOUSE_BENEFITS.FAILURE, error })
    }
}

export const getResource =
    ({ resourceId, resourceList = [], updateRedux = true }, successCallback = () => {}) =>
    async dispatch => {
        updateRedux && dispatch({ type: ACTIONS.GET_RESOURCE.START })

        // Avoid to call the database if the activity is already present
        const resource = resourceList.find(resource => resource.resourceId === resourceId)

        // getResources() doesn't return the correct outOfStock boolean, so we should hit the DB again for voucher resources
        if (resource && resource.automationType !== 'Voucher') {
            updateRedux && dispatch({ type: ACTIONS.GET_RESOURCE.SUCCESS, data: resource })
            successCallback(resource)
            return
        }
        try {
            const { payload } = await submitToApi({
                path: URL.DIRECTORY.V3_DIRECTORY_USER_RETRIEVE,
                query: { resourceId },
                url: URL.DIRECTORY.BASE,
            })
            updateRedux && dispatch({ type: ACTIONS.GET_RESOURCE.SUCCESS, data: payload.data })
            successCallback(payload.data)
        } catch (error) {
            updateRedux && dispatch({ type: ACTIONS.GET_RESOURCE.FAILURE, error })
        }
    }

export const getResourcePublic =
    (resourceId, successCallback = () => {}) =>
    async dispatch => {
        dispatch({ type: ACTIONS.GET_RESOURCE_PUBLIC.START })
        try {
            const { payload } = await submitToOpenApi({
                path: URL.DIRECTORY.V3_DIRECTORY_SHARED_RETRIEVE,
                query: { resourceId },
                url: URL.DIRECTORY.BASE,
            })
            dispatch({ type: ACTIONS.GET_RESOURCE_PUBLIC.SUCCESS, data: payload.data })
            successCallback(payload.data)
        } catch (error) {
            dispatch({ type: ACTIONS.GET_RESOURCE_PUBLIC.FAILURE, data: error })
        }
    }

export const cleanResource = () => dispatch => dispatch({ type: ACTIONS.CLEAN_RESOURCE })

export const changeFilters = filter => dispatch => dispatch({ type: ACTIONS.CHANGE_FILTERS, filter })
export const clearFilters = () => dispatch => dispatch({ type: ACTIONS.CLEAR_FILTERS })
export const changeBookingState = bookingState => dispatch => dispatch({ type: ACTIONS.CHANGE_BOOKING_STATE, bookingState })

export const getTopResources = () => async dispatch => {
    dispatch({ type: ACTIONS.GET_TOP_RESOURCES.START })
    try {
        const { payload } = await submitToApi({
            path: URL.DASHBOARD.V4_DASHBOARD_TOP_RESOURCES,
            url: URL.DASHBOARD.BASE,
        })
        dispatch({ type: ACTIONS.GET_TOP_RESOURCES.SUCCESS, data: payload.data })
    } catch (error) {
        dispatch({ type: ACTIONS.GET_TOP_RESOURCES.FAILURE, error })
    }
}
